export default {
  state: {
    parsed: null,
  },
  mutations: {
    updateParsed(state, val) {
      state.parsed = val;
    },
    updateField(state, { key, val }) {
      state.parsed[key] = val;
    },
    updateCol1(state, { key, val }) {
      if (state.parsed) {
        if (key != null) state.parsed.columnsIndecies1[key] = val;
      }
    },
    updateCol2(state, { key, val }) {
      if (state.parsed) {
        if (key != null) state.parsed.columnsIndecies2[key] = val;
      }
    },
  },
  getters: {
    parsed(state) {
      return state.parsed;
    },
    packageInitialSettingsOk(state) {
      let parsed = state.parsed;
      if (parsed != null) {
        return (
          parsed.AccCategoryRid != null &&
          parsed.CategoryRid != null &&
          parsed.goodsGroupRid != null &&
          parsed.packageGroupRid != null &&
          parsed.prepackGroupRid != null
        );
      }
      return false;
    },
    packageTreeColumns(state) {
      return state.parsed.columnsIndecies1;
    },
    decomplectColumns(state) {
      return state.parsed.columnsIndecies2;
    },
    packageTreeColumnsOk(state) {
      let cols1 = state.parsed.columnsIndecies1;
      return cols1.code != null && cols1.root != null && cols1.unit != null;
    },
    decomplectColumnsOk(state) {
      let cols2 = state.parsed.columnsIndecies2;
      return (
        cols2 != null &&
        cols2.brut != null &&
        cols2.code != null &&
        cols2.name != null &&
        cols2.type != null &&
        cols2.unit != null
      );
    },
  },
  actions: {
    clearParsed(ctx) {
      ctx.commit("updateParsed", null);
    },
    async parseFiles(ctx, { file1, file2, del1, del2 }) {
      let fd = new FormData();
      fd.append("file_first", file1);
      fd.append("file_second", file2);
      if (del1 != null) {
        fd.append("delimiter_first", del1);
      }
      if (del2 != null) {
        fd.append("delimiter_second", del2);
      }
      try {
        let res = await fetch(
          `${ctx.getters.url}/api/v1/sh/upload/pack/parse`,
          {
            method: "POST",
            body: fd,
          }
        );
        if (res.status == 200) {
          ctx.commit("updateParsed", await res.json());
          return true;
        } else {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        ctx.commit("updateMessage", {
          title: `Ошибка парсинга`,
          text: `Ошибка: ${error.message}`,
          isError: true,
        });
        return false;
      }
    },
    updateParsedByKey(ctx, { key, val }) {
      ctx.commit("updateField", { key, val });
    },
    updateCol1ByKey(ctx, { key, val }) {
      ctx.commit("updateCol1", { key, val });
    },
    updateCol2ByKey(ctx, { key, val }) {
      ctx.commit("updateCol2", { key, val });
    },
  },
  modules: {},
};
